define(
    'NMSDesignSystem.PLP.Shopping',
    [
        'Facets.Browse.View',
        'Facets.FacetedNavigation.View',
        'Facets.FacetedNavigationItem.View',
        'Facets.FacetsDisplay.View',
        'Facets.ItemCell.View',
        'Facets.Empty.View',
        'Cart.QuickAddToCart.View',
        'Cart.Confirmation.View',
        'NMSDesignSystem.ProductPrice.Shopping',
        'Product.Model',
        'Profile.Model',
        'Session',
        'Facets.Translator',
        'Configuration',
        'Backbone',
        'Handlebars',
        'jQuery',
        'underscore',
        'nms_facets_facet_browse.tpl',
        'nms_facets_faceted_navigation.tpl',
        'nms_facets_faceted_navigation_item.tpl',
        'nms_facets_item_cell_list.tpl',
        'nms_facets_item_cell_card.tpl',
        'nms_facets_item_action.tpl',
        'nms_facets_item_card_action.tpl',
        'nms_facets_empty.tpl',
        'nms_cart_confirmation_modal.tpl'
    ],
    function NMSDesignSystemPLPShopping(
        FacetsBrowseView,
        FacetsFacetedNavigationView,
        FacetsFacetedNavigationItemView,
        FacetsFacetsDisplayView,
        FacetsItemCellView,
        FacetsEmptyView,
        CartQuickAddToCartView,
        CartConfirmationView,
        NMSProductPriceView,
        ProductModel,
        ProfileModel,
        Session,
        FacetsTranslator,
        Configuration,
        Backbone,
        Handlebars,
        jQuery,
        _,
        nmsFacetsFacetBrowseTpl,
        nmsFacetsFacetedNavigationTpl,
        nmsFacetsFacetedNavigationItemTpl,
        nmsFacetsItemCellListTpl,
        nmsFacetsItemCellCardTpl,
        nmsFacetsItemActionTpl,
        nmsFacetsItemCardActionTpl,
        nmsFacetsEmptyTpl,
        nmsCartConfirmationModalTpl
    ) {
        'use strict';

        // SCA 2025.2 changed Configuration from a direct AMD export to a named export.
        Configuration = Configuration.Configuration || Configuration;
        ProfileModel = ProfileModel.ProfileModel || ProfileModel;

        var installed = false;
        var pendingFacetScroll = null;
        var pendingCollectionUpdate = null;
        var pendingCollectionRequest = null;
        var facetRequestRestarting = false;
        var categorySheetTrigger = null;
        var currentBrowseView = null;
        var nmsDisplayMode = 'list';
        var displayTransitionActive = false;
        var FACET_PREVIEW_COUNT = 3;
        var BUY_FLU_SHOTS_PRICE_FACET = 'pricelevel5';
        var LOGIN_TO_SEE_PRICE_FIELD = 'custitem_awa_login_to_see_price';
        var HIDDEN_FACETS = {
            category: true,
            commercecategoryname: true
        };
        var SEARCHABLE_FACETS = {
            custitemnms_facet_strength: {
                displayName: 'Strength',
                label: 'Search strengths',
                placeholder: 'Search strengths'
            },
            custitem_nms_facet_form: {
                displayName: 'Form',
                label: 'Search forms',
                placeholder: 'Search forms'
            },
            custitemnms_facet_manufacturer: {
                displayName: 'Manufacturer',
                label: 'Search manufacturers',
                placeholder: 'Search manufacturers'
            }
        };
        var SEARCHABLE_FACET_NAMES = {
            strength: SEARCHABLE_FACETS.custitemnms_facet_strength,
            form: SEARCHABLE_FACETS.custitem_nms_facet_form,
            manufacturer: SEARCHABLE_FACETS.custitemnms_facet_manufacturer
        };
        var PRIMARY_CATEGORIES = [
            {key: 'all', label: 'All Products', url: '/search'},
            {key: 'prescription', label: 'Prescription', url: '/products/prescription-medication'},
            {key: 'otc', label: 'OTC', url: '/products/over-the-counter-medication'},
            {key: 'health-beauty', label: 'Health & Beauty', url: '/products/health-beauty'},
            {key: 'medical-supplies', label: 'Medical Supplies', url: '/products/medical-supplies'},
            {key: 'animal-health', label: 'Animal Health', url: '/products/animal-health/general-medications'},
            {key: 'ems', label: 'EMS', url: '/products/ems'},
            {key: 'vaccines', label: 'Vaccines', url: '/products/other-vaccine'},
            {key: 'ppe', label: 'PPE', url: '/products/ppe'},
            {key: 'crash-cart', label: 'Crash Cart', url: '/search?keywords=crash%20cart'}
        ];
        var BUY_FLU_SHOTS_CATEGORIES = [
            {key: 'all', label: 'All Products', url: '/search'},
            {key: 'flu-vaccines', label: 'Flu Vaccines', url: '/products/flu-vaccines'},
            {key: 'vaccines', label: 'Vaccines', url: '/products/other-vaccine'},
            {key: 'vaccine-supplies', label: 'Vaccine Supplies', url: '/products/vaccine-supplies'},
            {key: 'ppe', label: 'PPE', url: '/products/ppe'}
        ];
        var ANIMAL_SUBCATEGORIES = [
            {key: 'animal-general', label: 'General Medications', url: '/products/animal-health/general-medications'},
            {key: 'animal-medical', label: 'Medical Supplies', url: '/products/animal-health/medical-supplies-ah'},
            {key: 'animal-oncology', label: 'Oncology Medications', url: '/products/animal-health/oncology-medications'},
            {key: 'animal-best-sellers', label: 'Best Sellers', url: '/products/animal-health/best-sellers'}
        ];
        var CATEGORY_INDICATOR_CONFIGS = [
            {
                railSelector: '.nms-products-category-rail',
                chipSelector: '.nms-products-category-chip',
                indicatorSelector: '.nms-products-category-indicator'
            },
            {
                railSelector: '.nms-products-animal-subchips',
                chipSelector: '.nms-products-animal-subchip',
                indicatorSelector: '.nms-products-animal-subindicator'
            }
        ];
        var ACRONYMS = {
            EMS: true,
            FDA: true,
            IM: true,
            IV: true,
            MCG: true,
            MG: true,
            ML: true,
            NDC: true,
            OTC: true,
            PPE: true,
            SQ: true,
            USP: true
        };

        function getNMSCardImageUrl(url) {
            // Whitespace is a srcset separator; encode it without double-encoding
            // existing escapes or changing the underlying image URL.
            return typeof url === 'string' ? url.replace(/[\t\n\f\r ]/g, function encodeCardWhitespace(value) {
                return encodeURIComponent(value);
            }) : url;
        }

        function installCardImageUrlHelper() {
            if (!Handlebars.helpers.nmsCardResizeImage) {
                Handlebars.registerHelper('nmsCardResizeImage', function nmsCardResizeImage(url, size) {
                    // Native views may supply mainImage only in the final template
                    // context. Preserve that value and the native fallback before
                    // encoding srcset separators in the finished image URL.
                    return getNMSCardImageUrl(Handlebars.helpers.resizeImage.apply(this, arguments));
                });
            }
        }

        function getNMSCardImagePreset(highDensity) {
            var sizes = typeof SC !== 'undefined' && SC.ENVIRONMENT && SC.ENVIRONMENT.siteSettings && SC.ENVIRONMENT.siteSettings.imagesizes;
            var name = highDensity ? 'nmscard2x' : 'nmscard';
            var dimension = highDensity ? 800 : 400;
            var present = _.find(sizes || [], function exactCardPreset(size) {
                return size && size.name === name && Number(size.maxwidth) === dimension && Number(size.maxheight) === dimension && size.urlsuffix;
            });
            // An absent or unexpected site preset retains the incumbent image size.
            return present ? name : (highDensity ? 'zoom' : 'main');
        }

        function normalizePath(value) {
            var path = String(value || '').split('?')[0].split('#')[0];

            if (path && path.charAt(0) !== '/') {
                path = '/' + path;
            }

            return path.length > 1 ? path.replace(/\/+$/, '') : path;
        }

        function normalizeKeywords(value) {
            return String(value || '').replace(/\+/g, ' ').replace(/^\s+|\s+$/g, '').toLowerCase();
        }

        function isBuyFluShotsSite() {
            var hostname = typeof window !== 'undefined' && window.location
                ? String(window.location.hostname || '').toLowerCase()
                : '';

            return hostname === 'buyflushots.nmsincusa.com' ||
                hostname === 'buyflu-sandbox.ethanablatt.com';
        }

        function isBuyFluShotsLocalPreview() {
            return isBuyFluShotsSite() &&
                typeof window !== 'undefined' &&
                /shopping-local\.ssp$/i.test(window.location.pathname);
        }

        function isEnabled(value) {
            return value === true || value === 'T' || value === 'true' || value === 1 || value === '1';
        }

        function getProductItem(model) {
            return model && (
                typeof model.getItem === 'function' && model.getItem() ||
                typeof model.get === 'function' && model.get('item') ||
                model.item
            );
        }

        function requiresProductsLogin(model) {
            return ProfileModel.getInstance().get('isLoggedIn') !== 'T' &&
                isEnabled(getItemValue(getProductItem(model), [LOGIN_TO_SEE_PRICE_FIELD]));
        }

        function productsLoginUrl() {
            var touchpoints = Session.get('touchpoints') || {};
            var base = String(touchpoints.login || touchpoints.register || '').replace(/#.*$/, '');

            if (isBuyFluShotsLocalPreview()) {
                return window.location.origin +
                    window.location.pathname.replace(/shopping-local\.ssp$/i, 'checkout-local.ssp') +
                    '?is=login&login=T#login-register';
            }

            return base ? base + '#login-register' : '/sca-dev-2020-1/checkout.ssp?is=login&login=T#login-register';
        }

        function installBuyFluShotsProductsRoute() {
            var route = /^products(?:\?([\s\S]*))?$/;
            var aliasHandler;

            if (!isBuyFluShotsLocalPreview() || !Backbone.history || Backbone.history.nmsProductsRouteInstalled) {
                return;
            }

            Backbone.history.nmsProductsRouteInstalled = true;
            Backbone.history.route(route, function showBuyFluShotsProducts(fragment) {
                var sourceFragment = String(fragment || 'products');
                var searchFragment = sourceFragment.replace(/^products/, 'search');
                var searchHandler = _.find(Backbone.history.handlers || [], function findSearchRoute(handler) {
                    if (!handler || handler === aliasHandler || !handler.route) {
                        return false;
                    }

                    return handler.route.test(searchFragment) && !handler.route.test(sourceFragment);
                });

                if (searchHandler) {
                    searchHandler.callback(searchFragment);
                }
            });
            aliasHandler = Backbone.history.handlers[0];
        }

        function isHiddenFacet(facetId) {
            return !!HIDDEN_FACETS[String(facetId || '').toLowerCase()];
        }

        function getFacetId(facet) {
            if (!facet) {
                return '';
            }

            if (typeof facet.get === 'function') {
                return String(facet.get('url') || facet.get('id') || '').toLowerCase();
            }

            return String(facet.url || facet.id || '').toLowerCase();
        }

        function isBuyFluShotsPriceFacet(facet) {
            return isBuyFluShotsSite() && getFacetId(facet) === BUY_FLU_SHOTS_PRICE_FACET;
        }

        function hasFacetQuery(fragment, translator) {
            var translatorConfig = translator && translator.configuration;
            var facetIds = _.map(translatorConfig && translatorConfig.facets || [], function getConfiguredFacetId(facet) {
                return String(facet.id || facet.url || '').toLowerCase();
            });
            var query = String(fragment || '').split('?')[1] || '';
            var queryKeys = _.map(query.split('&'), function getQueryKey(option) {
                return String(option || '').split('=')[0].toLowerCase();
            });

            facetIds = _.union(facetIds, _.map(translator && translator.facetsToInclude || [], function getIncludedFacetId(facetId) {
                return String(facetId || '').toLowerCase();
            }));

            return _.some(facetIds, function findQueryFacet(facetId) {
                return _.contains(queryKeys, facetId);
            });
        }

        function withFacetUrlParameters(translator, callback) {
            var configuration = translator && translator.configuration;
            var originalDefault;
            var originalParameters;
            var result;

            if (!configuration) {
                return callback();
            }

            originalDefault = configuration.facetsAsUrlParameters;
            originalParameters = _.map(configuration.facets || [], function rememberParameter(facet) {
                return {
                    facet: facet,
                    hasParameterValue: Object.prototype.hasOwnProperty.call(facet, 'isParameter'),
                    parameterValue: facet.isParameter
                };
            });
            configuration.facetsAsUrlParameters = true;
            _.each(configuration.facets || [], function useQueryParameter(facet) {
                var facetId = getFacetId(facet);

                if (facetId !== 'category' && facetId !== 'commercecategoryname') {
                    facet.isParameter = true;
                }
            });

            try {
                result = callback();
            } finally {
                configuration.facetsAsUrlParameters = originalDefault;
                _.each(originalParameters, function restoreParameter(entry) {
                    if (entry.hasParameterValue) {
                        entry.facet.isParameter = entry.parameterValue;
                    } else {
                        delete entry.facet.isParameter;
                    }
                });
            }

            return result;
        }

        function isNMSStorefront() {
            var hostname = typeof window !== 'undefined' && window.location
                ? String(window.location.hostname || '').toLowerCase()
                : '';

            return hostname === 'nmsincusa.com' ||
                hostname === 'www.nmsincusa.com' ||
                hostname === 'buyflushots.nmsincusa.com' ||
                hostname === 'buyflu-sandbox.ethanablatt.com';
        }

        function getVisibleUrl() {
            if (typeof window === 'undefined' || !window.location) {
                return '';
            }

            return window.location.pathname + window.location.search + window.location.hash;
        }

        function stripDisplayOption(url) {
            var source = String(url || '');
            var hashIndex = source.indexOf('#');
            var hash = hashIndex >= 0 ? source.slice(hashIndex) : '';
            var withoutHash = hashIndex >= 0 ? source.slice(0, hashIndex) : source;
            var queryIndex = withoutHash.indexOf('?');
            var path = queryIndex >= 0 ? withoutHash.slice(0, queryIndex) : withoutHash;
            var query = queryIndex >= 0 ? withoutHash.slice(queryIndex + 1) : '';
            var cleanedQuery = _.filter(query.split('&'), function keepNonDisplayOption(option) {
                return option && String(option.split('=')[0] || '').toLowerCase() !== 'display';
            }).join('&');

            return path + (cleanedQuery ? '?' + cleanedQuery : '') + hash;
        }

        function cleanVisibleDisplayOption() {
            var visibleUrl;
            var cleanUrl;

            if (typeof window === 'undefined' || !window.history) {
                return;
            }

            visibleUrl = getVisibleUrl();
            cleanUrl = stripDisplayOption(visibleUrl);

            if (cleanUrl !== visibleUrl) {
                window.history.replaceState(window.history.state, document.title, cleanUrl);
            }
        }

        function applyDisplayMode(view, mode) {
            var nextMode = mode === 'card' ? 'card' : 'list';

            nmsDisplayMode = nextMode;

            if (!view || !view.translator || !view.translator.cloneForOption) {
                return;
            }

            view.translator = view.translator.cloneForOption('display', nextMode);
            view.setOptionsTranslator();

            if (view.model && view.model.options) {
                view.model.options.data = view.translator.getApiParams();
            }
        }

        function restoreDisplayModePushables(view) {
            // Native showContent installs scPush once; a display-only render replaces
            // those nodes without running showContent again.
            var pushables = view.$('[data-action="pushable"]:not([data-pusher])');

            if (pushables.length && typeof pushables.scPush === 'function') {
                pushables.scPush({target: 'tablet'});
            }
        }

        function bindDisplayModeLifecycle() {
            jQuery(document)
                .off('.nmsProductDisplayMode')
                .on('click.nmsProductDisplayMode', '[data-nms-display-mode]', function switchNMSProductDisplay(event) {
                    var mode = String(jQuery(event.currentTarget).attr('data-nms-display-mode') || '');
                    var page;
                    var controls;
                    var renderNextMode;

                    event.preventDefault();

                    if (
                        !currentBrowseView ||
                        displayTransitionActive ||
                        pendingCollectionUpdate ||
                        (mode !== 'list' && mode !== 'card') ||
                        mode === nmsDisplayMode
                    ) {
                        return;
                    }

                    page = currentBrowseView.$('.nms-products-page').first();
                    controls = page.find('[data-nms-display-mode]');
                    displayTransitionActive = true;

                    controls.each(function syncDisplayControl() {
                        var control = jQuery(this);
                        var isActive = control.attr('data-nms-display-mode') === mode;

                        control.toggleClass('is-active', isActive).attr('aria-pressed', isActive ? 'true' : 'false');
                    });

                    renderNextMode = function renderNextNMSDisplayMode() {
                        applyDisplayMode(currentBrowseView, mode);
                        cleanVisibleDisplayOption();
                        currentBrowseView.render();
                        restoreDisplayModePushables(currentBrowseView);

                        window.requestAnimationFrame(function revealNMSDisplayMode() {
                            window.requestAnimationFrame(function settleNMSDisplayMode() {
                                var nextPage = currentBrowseView.$('.nms-products-page').first();

                                nextPage.removeClass('is-display-entering');
                                displayTransitionActive = false;
                            });
                        });
                    };
                    window.requestAnimationFrame(function acknowledgeNMSDisplayMode() {
                        window.requestAnimationFrame(renderNextMode);
                    });
                });
        }

        function installFacetTranslator() {
            var originalGetUrl = FacetsTranslator.prototype.getUrl;
            var originalParseUrl = FacetsTranslator.prototype.parseUrl;
            var originalGetFacetConfig = FacetsTranslator.prototype.getFacetConfig;

            FacetsTranslator.prototype.getFacetConfig = function getNMSFacetConfig(facetId) {
                var config = originalGetFacetConfig.apply(this, arguments);
                var resolvedFacetId = getFacetId(config) || String(facetId || '').toLowerCase();

                if (
                    isBuyFluShotsSite() &&
                    !isHiddenFacet(resolvedFacetId) &&
                    resolvedFacetId !== BUY_FLU_SHOTS_PRICE_FACET &&
                    config.behavior !== 'range'
                ) {
                    return _.extend({}, config, {behavior: 'multi'});
                }

                return config;
            };

            FacetsTranslator.prototype.getUrl = function getNMSFacetUrl() {
                var translator = this;
                var args = arguments;
                var url;

                if (!isNMSStorefront()) {
                    return originalGetUrl.apply(this, args);
                }

                url = withFacetUrlParameters(this, function buildQueryFacetUrl() {
                    return originalGetUrl.apply(translator, args);
                });

                if (
                    isBuyFluShotsLocalPreview() &&
                    /^#\/?products(?:\?|$)/.test(window.location.hash) &&
                    /^\/search(?:\?|$)/.test(url)
                ) {
                    url = url.replace(/^\/search/, '/products');
                }

                return stripDisplayOption(url);
            };

            FacetsTranslator.prototype.parseUrl = function parseNMSFacetUrl(fragment) {
                var translator = this;
                var args = Array.prototype.slice.call(arguments);

                if (isBuyFluShotsLocalPreview() && /^\/?products(?:\?|$)/.test(String(fragment || ''))) {
                    args[0] = String(fragment).replace(/^\/?products/, 'search');
                    fragment = args[0];
                }

                if (isNMSStorefront() && hasFacetQuery(fragment, this)) {
                    return withFacetUrlParameters(this, function parseQueryFacets() {
                        return originalParseUrl.apply(translator, args);
                    });
                }

                return originalParseUrl.apply(this, args);
            };
        }

        function installCardDisplayOption() {
            var displayOptions = Configuration.get('itemsDisplayOptions') || [];
            var cardOption = _.findWhere(displayOptions, {id: 'card'});

            if (!cardOption) {
                displayOptions.push({
                    id: 'card',
                    name: 'Card view',
                    template: nmsFacetsItemCellCardTpl,
                    columns: 1
                });
            }
        }

        function getSearchableFacet(context) {
            var facetId = String(context.facetId || '').replace(/^\s+|\s+$/g, '').toLowerCase();
            var displayName = String(context.facetDisplayName || '').replace(/^\s+|\s+$/g, '').toLowerCase();

            return SEARCHABLE_FACETS[facetId] || SEARCHABLE_FACET_NAMES[displayName];
        }

        function getVisibleAppliedFacets(translator) {
            var visibleTranslator = translator;
            var facetIds = _.keys(HIDDEN_FACETS);

            if (!visibleTranslator || !visibleTranslator.cloneWithoutFacetId) {
                return [];
            }

            if (isBuyFluShotsSite()) {
                facetIds.push(BUY_FLU_SHOTS_PRICE_FACET);
            }

            _.each(facetIds, function removeHiddenFacet(facetId, index) {
                // Keep one native deep copy: FacetsDisplay mutates its facet values.
                // Further copies are only needed when a hidden facet is present.
                if (index === 0 || _.findWhere(visibleTranslator.getAllFacets(), {id: facetId})) {
                    visibleTranslator = visibleTranslator.cloneWithoutFacetId(facetId);
                }
            });

            return visibleTranslator.getAllFacets();
        }

        function formatCatalogLabel(value) {
            var source = String(value || '').replace(/^\s+|\s+$/g, '');

            if (!source || source !== source.toUpperCase()) {
                return source;
            }

            return source.toLowerCase().replace(/[a-z0-9]+(?:['’][a-z0-9]+)*/g, function formatToken(token) {
                var upper = token.toUpperCase();

                if (ACRONYMS[upper] || /\d/.test(token)) {
                    return upper;
                }

                return token.charAt(0).toUpperCase() + token.slice(1);
            });
        }

        function getCategoryPath(view) {
            var category = view.model && view.model.get('category');
            var translated = view.translator && view.translator.getCategoryUrl
                ? view.translator.getCategoryUrl()
                : '';

            return normalizePath(translated || (category && category.get('fullurl')));
        }

        function getCategoryName(view) {
            var category = view.model && view.model.get('category');

            return formatCatalogLabel(category && (
                category.get('pageheading') ||
                category.get('name') ||
                category.get('itemid')
            ));
        }

        function isPrimaryCategoryActive(category, categoryPath, keywords) {
            if (category.key === 'all') {
                return !keywords && (
                    !categoryPath ||
                    categoryPath === '/products' ||
                    categoryPath === '/search'
                );
            }

            if (category.key === 'crash-cart') {
                return keywords === 'crash cart';
            }

            if (category.key === 'animal-health') {
                return categoryPath.indexOf('/products/animal-health/') === 0;
            }

            return categoryPath === normalizePath(category.url);
        }

        function buildCategoryContext(view) {
            var categoryPath = getCategoryPath(view);
            var rawKeywords = String(view.translator.getOptionValue('keywords') || '').replace(/\s+/g, ' ').trim();
            var keywords = normalizeKeywords(rawKeywords);
            var categoryName = getCategoryName(view);
            var isAnimalHealth = categoryPath.indexOf('/products/animal-health/') === 0;
            var heading = categoryName || (rawKeywords ? 'Search for: ' + rawKeywords : 'All Products');
            var total = Number(view.model && view.model.get('total')) || 0;
            var subtitle = total === 1 ? '1 Product' : total + ' Products';
            var isCatalogRoot = !keywords && (
                !categoryPath ||
                categoryPath === '/products' ||
                categoryPath === '/search'
            );
            var breadcrumbCurrent = categoryName || (
                rawKeywords ? (keywords === 'crash cart' ? 'Crash Cart' : 'Search for: ' + rawKeywords) : ''
            );
            var primaryCategories = isBuyFluShotsSite() ? BUY_FLU_SHOTS_CATEGORIES : PRIMARY_CATEGORIES;

            if (isCatalogRoot) {
                breadcrumbCurrent = '';
            }

            return {
                categoryPath: categoryPath,
                categories: _.map(primaryCategories, function mapPrimaryCategory(category) {
                    return _.extend({}, category, {
                        isAnimalHealth: category.key === 'animal-health',
                        isActive: isPrimaryCategoryActive(category, categoryPath, keywords)
                    });
                }),
                animalSubcategories: _.map(ANIMAL_SUBCATEGORIES, function mapAnimalCategory(category) {
                    return _.extend({}, category, {
                        isActive: categoryPath === normalizePath(category.url)
                    });
                }),
                showAnimalSubcategories: isAnimalHealth,
                heading: heading,
                subtitle: subtitle,
                breadcrumbParent: isAnimalHealth ? 'Animal Health' : '',
                breadcrumbParentUrl: isAnimalHealth ? '/products/animal-health/general-medications' : '',
                breadcrumbCurrent: breadcrumbCurrent
            };
        }

        function closeCategorySheet(restoreFocus) {
            var $sheet = jQuery('#nms-products-category-sheet');

            $sheet.removeClass('is-open').attr('aria-hidden', 'true');
            jQuery('[data-nms-category-sheet-open]').attr('aria-expanded', 'false');
            jQuery('body').removeClass('nms-products-category-sheet-open');

            if (restoreFocus && categorySheetTrigger && document.documentElement.contains(categorySheetTrigger)) {
                categorySheetTrigger.focus();
            }
            categorySheetTrigger = null;
        }

        function bindCategorySheetLifecycle() {
            jQuery(document)
                .off('.nmsProductCategorySheet')
                .on('click.nmsProductCategorySheet', '[data-nms-category-sheet-open]', function openCategorySheet(event) {
                    var $sheet = jQuery('#nms-products-category-sheet');

                    event.preventDefault();
                    categorySheetTrigger = event.currentTarget;
                    $sheet.addClass('is-open').attr('aria-hidden', 'false');
                    jQuery(event.currentTarget).attr('aria-expanded', 'true');
                    jQuery('body').addClass('nms-products-category-sheet-open');
                    $sheet.find('[data-nms-category-sheet-close]').focus();
                })
                .on('click.nmsProductCategorySheet', '[data-nms-category-sheet-close]', function closeCategorySheetButton(event) {
                    event.preventDefault();
                    closeCategorySheet(true);
                })
                .on('click.nmsProductCategorySheet', '#nms-products-category-sheet a', function closeCategorySheetLink() {
                    closeCategorySheet(false);
                })
                .on('keydown.nmsProductCategorySheet', function closeCategorySheetWithEscape(event) {
                    if (event.key === 'Escape' && jQuery('body').hasClass('nms-products-category-sheet-open')) {
                        event.preventDefault();
                        closeCategorySheet(true);
                    }
                });
        }

        function getItemValue(model, fields) {
            var value;

            _.some(fields, function findValue(field) {
                value = model.get(field);
                return value !== null && value !== undefined && value !== '';
            });

            return value || '—';
        }

        function captureFacetScroll(view, scrollToTop) {
            var panel = view.$('.facets-facet-browse-facets').get(0);

            pendingFacetScroll = {
                pageY: window.pageYOffset || document.documentElement.scrollTop || 0,
                panelY: panel ? panel.scrollTop : 0,
                scrollToTop: !!scrollToTop || !!(
                    pendingFacetScroll && pendingFacetScroll.scrollToTop
                )
            };
        }

        function scrollProductsPageToTop() {
            var reduceMotion = !!(
                window.matchMedia &&
                window.matchMedia('(prefers-reduced-motion: reduce)').matches
            );

            try {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: reduceMotion ? 'auto' : 'smooth'
                });
            } catch (error) {
                window.scrollTo(0, 0);
            }
        }

        function restoreFacetScroll(view) {
            var state = pendingFacetScroll;
            var panel;

            if (!state || typeof window === 'undefined') {
                return;
            }

            pendingFacetScroll = null;
            panel = view.$('.facets-facet-browse-facets').get(0);

            if (panel) {
                panel.scrollTop = state.panelY;
            }

            if (state.scrollToTop) {
                window.scrollTo(0, state.pageY);
                window.requestAnimationFrame(scrollProductsPageToTop);
                return;
            }

            if ((window.pageYOffset || document.documentElement.scrollTop || 0) !== state.pageY) {
                window.scrollTo(0, state.pageY);
            }
        }

        function normalizeMotionLabel(value) {
            return String(value || '').replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '').toLowerCase();
        }

        function getCategoryIndicatorMetrics(rail, element) {
            var railRect = rail.getBoundingClientRect();
            var elementRect = element.getBoundingClientRect();

            return {
                left: elementRect.left - railRect.left + rail.scrollLeft,
                width: elementRect.width
            };
        }

        function measureCategoryIndicator(view, config) {
            var rail = view && view.$(config.railSelector).get(0);
            var indicator;
            var activeChip;

            if (!rail) return null;
            indicator = jQuery(rail).find(config.indicatorSelector).get(0);
            activeChip = jQuery(rail).find(config.chipSelector + '.is-active').get(0);
            if (!indicator || !activeChip) return null;
            return { rail: rail, indicator: indicator, metrics: getCategoryIndicatorMetrics(rail, activeChip) };
        }

        function applyCategoryIndicator(state) {
            if (!state) return;
            jQuery(state.indicator)
                .removeClass('is-moving')
                .css({
                    left: state.metrics.left + 'px',
                    width: state.metrics.width + 'px',
                    transform: 'translate3d(0, 0, 0) scaleX(1)'
                });
            jQuery(state.rail).addClass('is-indicator-ready');
        }

        function syncSingleCategoryIndicator(view, config) {
            applyCategoryIndicator(measureCategoryIndicator(view, config));
        }

        function syncCategoryIndicator(view) {
            // Read both rails before writing either indicator. A write between
            // measurements otherwise forces the second rail to lay out again.
            var states = _.map(CATEGORY_INDICATOR_CONFIGS, function measureConfiguredIndicator(config) {
                return measureCategoryIndicator(view, config);
            });
            _.each(states, applyCategoryIndicator);
        }

        function getCategoryIndicatorConfig(element) {
            return _.find(CATEGORY_INDICATOR_CONFIGS, function findCategoryIndicatorConfig(config) {
                return jQuery(element).is(config.chipSelector);
            });
        }

        function animateCategoryIndicator(target) {
            var chip = jQuery(target);
            var config = getCategoryIndicatorConfig(target);
            var rail = config && chip.closest(config.railSelector).get(0);
            var indicator;
            var indicatorRect;
            var railRect;
            var targetMetrics;
            var sourceLeft;
            var sourceWidth;
            var widthRatio;

            if (!rail) {
                return;
            }

            indicator = jQuery(rail).find(config.indicatorSelector).get(0);
            if (!indicator) {
                return;
            }

            if (!jQuery(rail).hasClass('is-indicator-ready') && currentBrowseView) {
                syncSingleCategoryIndicator(currentBrowseView, config);
            }

            indicatorRect = indicator.getBoundingClientRect();
            railRect = rail.getBoundingClientRect();
            targetMetrics = getCategoryIndicatorMetrics(rail, chip.get(0));
            sourceLeft = indicatorRect.left - railRect.left + rail.scrollLeft;
            sourceWidth = indicatorRect.width || targetMetrics.width;
            widthRatio = targetMetrics.width ? sourceWidth / targetMetrics.width : 1;

            jQuery(rail)
                .find(config.chipSelector + '.is-category-pending, ' + config.chipSelector + '.is-category-departing')
                .removeClass('is-category-pending is-category-departing');
            jQuery(rail).find(config.chipSelector + '.is-active').addClass('is-category-departing');
            chip.addClass('is-category-pending');

            jQuery(indicator)
                .removeClass('is-moving')
                .css({
                    left: targetMetrics.left + 'px',
                    width: targetMetrics.width + 'px',
                    transform: 'translate3d(' + (sourceLeft - targetMetrics.left) + 'px, 0, 0) scaleX(' + widthRatio + ')'
                });
            var motion = (indicator.nmsCategoryMotion || 0) + 1;
            indicator.nmsCategoryMotion = motion;
            // Split starting/final transforms across frames; do not force layout.
            window.requestAnimationFrame(function startNMSCategoryIndicator() {
                window.requestAnimationFrame(function moveNMSCategoryIndicator() {
                    if (indicator.nmsCategoryMotion !== motion || !document.documentElement.contains(indicator)) return;
                    jQuery(indicator).addClass('is-moving')
                        .one('transitionend.nmsCategoryIndicator', function finishNMSCategoryIndicator(event) {
                            if (event.originalEvent && event.originalEvent.propertyName !== 'transform') return;
                            jQuery(indicator).removeClass('is-moving');
                        }).css('transform', 'translate3d(0, 0, 0) scaleX(1)');
                });
            });
        }

        function getCategoryTitleDirection(target) {
            var chip = jQuery(target);
            var config = getCategoryIndicatorConfig(target);
            var rail = config && chip.closest(config.railSelector);
            var chips;
            var activeIndex;
            var targetIndex;

            if (!rail || !rail.length) {
                return 1;
            }

            chips = rail.find(config.chipSelector);
            activeIndex = chips.index(chips.filter('.is-active').first());
            targetIndex = chips.index(chip);

            if (activeIndex < 0 || targetIndex < 0 || activeIndex === targetIndex) {
                return 1;
            }

            return targetIndex > activeIndex ? 1 : -1;
        }

        function getAppliedFacetLabels(scope) {
            return scope.find('.facets-facets-display-filter').map(function readAppliedFacetLabel() {
                var chip = jQuery(this).clone();

                chip.find('i').remove();
                return normalizeMotionLabel(chip.text());
            }).get();
        }

        function setInPageRequestState(isActive) {
            if (typeof window !== 'undefined') {
                window.NMSInPageUpdateActive = !!isActive;
            }
        }

        function getFacetParameterIds(view) {
            var translator = view && view.translator;
            var configuration = translator && translator.configuration;
            var ids = _.map(configuration && configuration.facets || [], function getFacetParameterId(facet) {
                return getFacetId(facet);
            });

            return _.union(ids, _.map(translator && translator.facetsToInclude || [], function getIncludedFacetParameterId(facetId) {
                return String(facetId || '').toLowerCase();
            }));
        }

        function parseFacetUrl(url) {
            var source = String(url || '').replace(/&amp;/g, '&');
            var hashIndex = source.indexOf('#');
            var prefix = hashIndex >= 0 ? source.slice(0, hashIndex + 1) : '';
            var route = hashIndex >= 0 ? source.slice(hashIndex + 1) : source;
            var queryIndex = route.indexOf('?');

            return {
                prefix: prefix,
                path: queryIndex >= 0 ? route.slice(0, queryIndex) : route,
                query: queryIndex >= 0 ? route.slice(queryIndex + 1) : ''
            };
        }

        function mergeFacetRequestUrls(currentUrl, nextUrl, view) {
            var current = parseFacetUrl(currentUrl);
            var next = parseFacetUrl(nextUrl);
            var facetIds = getFacetParameterIds(view);
            var currentParams = _.filter(current.query.split('&'), function keepCurrentParameter(parameter) {
                return parameter;
            });
            var nextParams = _.filter(next.query.split('&'), function keepNextParameter(parameter) {
                return parameter;
            });
            var valuesByKey = {};

            _.each(currentParams, function collectCurrentFacetValues(parameter) {
                var parts = parameter.split('=');
                var key = decodeURIComponent(parts.shift() || '').toLowerCase();
                var value = parts.join('=');

                if (_.contains(facetIds, key)) {
                    valuesByKey[key] = {
                        key: parameter.split('=')[0],
                        values: _.filter(decodeURIComponent(value || '').split(','), function keepFacetValue(facetValue) {
                            return facetValue !== '';
                        })
                    };
                }
            });

            _.each(nextParams, function mergeNextFacetValues(parameter) {
                var parts = parameter.split('=');
                var encodedKey = parts.shift() || '';
                var key = decodeURIComponent(encodedKey).toLowerCase();
                var values = _.filter(decodeURIComponent(parts.join('=') || '').split(','), function keepFacetValue(facetValue) {
                    return facetValue !== '';
                });

                if (_.contains(facetIds, key)) {
                    valuesByKey[key] = valuesByKey[key] || {key: encodedKey, values: []};
                    valuesByKey[key].values = _.union(valuesByKey[key].values, values);
                }
            });

            currentParams = _.reject(currentParams, function removeMergedFacetParameters(parameter) {
                return _.contains(facetIds, decodeURIComponent(parameter.split('=')[0] || '').toLowerCase());
            });
            _.each(valuesByKey, function appendMergedFacetParameter(entry) {
                currentParams.push(entry.key + '=' + _.map(entry.values, encodeURIComponent).join(','));
            });

            return current.prefix + current.path + (currentParams.length ? '?' + currentParams.join('&') : '');
        }

        function toggleOptimisticFacet(state, target) {
            var facetCheckbox;
            var facetWasActive;
            var facetWasChecked;

            if (!target.is('.facets-faceted-navigation-item-facet-option') || target.hasClass('is-filter-pending')) {
                return;
            }

            facetCheckbox = target.find('.facets-faceted-navigation-item-facet-multi').first();
            if (!facetCheckbox.length) {
                return;
            }

            facetWasActive = target.hasClass('option-active');
            facetWasChecked = facetCheckbox.hasClass('is-checked');
            state.optimisticFacets = state.optimisticFacets || [];
            state.optimisticFacets.push({
                element: target.get(0),
                checkbox: facetCheckbox.get(0),
                wasActive: facetWasActive,
                wasChecked: facetWasChecked
            });
            target.toggleClass('option-active', !facetWasActive);
            facetCheckbox.toggleClass('is-checked', !facetWasChecked);
            target.addClass('is-filter-pending');
        }

        function restartFacetRequest(event, target) {
            var state = pendingCollectionUpdate;
            var mergedUrl;

            if (!state || !currentBrowseView) {
                return false;
            }

            event.preventDefault();
            event.stopImmediatePropagation();
            toggleOptimisticFacet(state, target);
            mergedUrl = mergeFacetRequestUrls(state.requestUrl || getVisibleUrl(), target.attr('href'), currentBrowseView);
            state.requestUrl = mergedUrl;
            if (!state.isFacetRestartPending) {
                state.isFacetRestartPending = true;
                window.setTimeout(function sendMergedFacetRequest(attempt) {
                    if (!pendingCollectionRequest && attempt < 4) {
                        window.setTimeout(function waitForFacetRequest() {
                            sendMergedFacetRequest(attempt + 1);
                        }, 0);
                        return;
                    }

                    if (pendingCollectionRequest && typeof pendingCollectionRequest.abort === 'function') {
                        facetRequestRestarting = true;
                        state.abortedRequest = pendingCollectionRequest;
                        pendingCollectionRequest.abort();
                    }

                    facetRequestRestarting = false;
                    state.isFacetRestartPending = false;
                    target.attr('href', state.requestUrl).attr('data-nms-facet-restart', 'true');
                    target.get(0).click();
                }, 0, 0);
            }

            return true;
        }

        function beginCollectionUpdate(target, reason) {
            var page = jQuery('.nms-products-page').first();
            var currentTarget = target && jQuery(target);
            var changesCategoryTitle = !!(
                currentTarget &&
                currentTarget.is('.nms-products-category-chip, .nms-products-animal-subchip')
            );
            var selectedFacets;
            var clearsAllFacets;

            if (!page.length) {
                return;
            }

            if (!pendingCollectionUpdate) {
                pendingCollectionUpdate = {
                    reason: reason || 'results',
                    facetLabels: getAppliedFacetLabels(page),
                    requestUrl: currentTarget && currentTarget.attr('href') || getVisibleUrl(),
                    changesCategoryTitle: changesCategoryTitle,
                    previousCategoryTitleHtml: changesCategoryTitle
                        ? page.find('.facets-browse-category-heading-main-description').first().html()
                        : '',
                    categoryTitleDirection: changesCategoryTitle
                        ? getCategoryTitleDirection(currentTarget.get(0))
                        : 1
                };
            } else if (changesCategoryTitle) {
                pendingCollectionUpdate.changesCategoryTitle = true;
                pendingCollectionUpdate.categoryTitleDirection = getCategoryTitleDirection(currentTarget.get(0));
            }

            setInPageRequestState(true);
            page.addClass('is-collection-updating').attr('aria-busy', 'true');

            if (currentTarget && currentTarget.length) {
                selectedFacets = page.find('.facets-facets-display-filter');
                clearsAllFacets = currentTarget.is(
                    '.facets-facets-display-clear, .facets-faceted-navigation-facets-clear'
                );

                if (currentTarget.is('.facets-faceted-navigation-item-facet-option')) {
                    toggleOptimisticFacet(pendingCollectionUpdate, currentTarget);
                }

                currentTarget.addClass('is-filter-pending');

                if (currentTarget.is('[data-type="facet-selected"]')) {
                    currentTarget
                        .removeClass('is-filter-chip-entering')
                        .addClass('is-filter-chip-exiting');
                }

                if (
                    clearsAllFacets ||
                    selectedFacets.length === 1 && currentTarget.is(
                        '[data-type="facet-selected"], .facets-faceted-navigation-item-facet-clear'
                    )
                ) {
                    page.find('.nms-filters-panel-selected').addClass('is-exiting');
                }
            }
        }

        function animateLoadedCategoryTitle(page, state) {
            var title = page.find('.facets-browse-category-heading-main-description').first();
            var titleRow = title.closest('.nms-products-title-row');
            var previousTitle;
            var directionClass;
            var cleanupTimer;
            var finishTransition;

            if (
                !state ||
                !state.changesCategoryTitle ||
                !state.previousCategoryTitleHtml ||
                !title.length ||
                !titleRow.length
            ) {
                page.removeClass('is-category-title-entering is-category-title-updating');
                return;
            }

            directionClass = state.categoryTitleDirection < 0
                ? 'is-category-title-moving-left'
                : 'is-category-title-moving-right';
            previousTitle = jQuery('<div class="facets-browse-category-heading-main-description nms-category-title-previous" aria-hidden="true"></div>')
                .html(state.previousCategoryTitleHtml)
                .appendTo(titleRow);

            finishTransition = function finishNMSCategoryTitleTransition() {
                window.clearTimeout(cleanupTimer);
                previousTitle.remove();
                page.removeClass(
                    'is-category-title-entering is-category-title-updating ' +
                    'is-category-title-transitioning is-category-title-moving-left is-category-title-moving-right'
                );
            };

            title.one('animationend.nmsCategoryTitle', finishTransition);
            page
                .addClass('is-category-title-transitioning ' + directionClass)
                .removeClass('is-category-title-entering is-category-title-updating');
            cleanupTimer = window.setTimeout(finishTransition, 300);
        }

        function revealCollectionUpdate(view) {
            var state = pendingCollectionUpdate;
            var page = view.$('.nms-products-page').first();
            var previousLabels = state && state.facetLabels || [];
            var selectedTray;

            pendingCollectionUpdate = null;
            setInPageRequestState(false);

            if (!page.length) {
                return;
            }

            syncCategoryIndicator(view);
            animateLoadedCategoryTitle(page, state);

            selectedTray = page.find('.nms-filters-panel-selected.is-entering');
            selectedTray
                .addClass('is-visible')
                .on('transitionend.nmsSelectedTrayEnter', function finishNMSSelectedTrayEntry(event) {
                    if (
                        event.target !== this ||
                        event.originalEvent && event.originalEvent.propertyName !== 'grid-template-rows'
                    ) {
                        return;
                    }

                    selectedTray
                        .off('transitionend.nmsSelectedTrayEnter')
                        .removeClass('is-entering is-visible');
                });
            page.find('.facets-facets-display-filter').each(function markNewFacetChip() {
                var chip = jQuery(this);
                var clone = chip.clone();
                var label;

                clone.find('i').remove();
                label = normalizeMotionLabel(clone.text());
                if (!_.contains(previousLabels, label)) {
                    chip
                        .addClass('is-filter-chip-entering')
                        .one('animationend.nmsFilterChipEnter', function finishNMSFilterChipEntry() {
                            chip.removeClass('is-filter-chip-entering');
                        });
                }
            });

            window.requestAnimationFrame(function revealNMSCollection() {
                window.requestAnimationFrame(function settleNMSCollection() {
                    page
                        .removeClass('is-collection-entering is-collection-updating')
                        .removeAttr('aria-busy');
                });
            });
        }

        function cancelCollectionUpdate() {
            var state = pendingCollectionUpdate;
            var optimisticFacets = state && state.optimisticFacets || [];

            _.each(optimisticFacets, function restoreOptimisticFacet(optimisticFacet) {
                jQuery(optimisticFacet.element)
                    .toggleClass('option-active', optimisticFacet.wasActive)
                    .removeClass('is-filter-pending');
                jQuery(optimisticFacet.checkbox).toggleClass('is-checked', optimisticFacet.wasChecked);
            });

            pendingCollectionUpdate = null;
            setInPageRequestState(false);
            jQuery('.nms-products-page')
                .removeClass('is-collection-entering is-collection-updating is-category-title-entering is-category-title-updating')
                .removeAttr('aria-busy');

            if (currentBrowseView) {
                currentBrowseView.$('.nms-products-category-chip, .nms-products-animal-subchip')
                    .removeClass('is-category-pending is-category-departing');
                syncCategoryIndicator(currentBrowseView);
            }
        }

        function markFacetUpdateStarted(event) {
            var target = event && event.currentTarget;

            beginCollectionUpdate(target, 'facets');
        }

        function installBrowseView() {
            var originalInitialize = FacetsBrowseView.prototype.initialize;
            var originalGetContext = FacetsBrowseView.prototype.getContext;
            var originalGetTitle = FacetsBrowseView.prototype.getTitle;
            var originalGotoFacets = FacetsBrowseView.prototype._gotoFacets;
            var originalShowContent = FacetsBrowseView.prototype.showContent;

            FacetsBrowseView.prototype.template = nmsFacetsFacetBrowseTpl;

            FacetsBrowseView.prototype.initialize = function initializeNMSProducts() {
                originalInitialize.apply(this, arguments);
                currentBrowseView = this;
                cleanVisibleDisplayOption();
                applyDisplayMode(this, nmsDisplayMode);

                if (
                    isBuyFluShotsSite() &&
                    this.translator &&
                    this.translator.getFacetValue(BUY_FLU_SHOTS_PRICE_FACET)
                ) {
                    this.translator = this.translator.cloneWithoutFacetId(BUY_FLU_SHOTS_PRICE_FACET);
                    this.setOptionsTranslator();
                    this.model.options.data = this.translator.getApiParams();
                }

                _.each(this.itemsDisplayOptions || [], function useNMSRowTemplate(option) {
                    option.template = nmsFacetsItemCellListTpl;
                    option.columns = 1;
                });

                var cardOption = _.findWhere(this.itemsDisplayOptions || [], {id: 'card'});

                if (cardOption) {
                    cardOption.template = nmsFacetsItemCellCardTpl;
                }
            };

            FacetsBrowseView.prototype.getContext = function getNMSProductsContext() {
                var context = originalGetContext.apply(this, arguments);
                var categoryContext = buildCategoryContext(this);
                var appliedFacets = getVisibleAppliedFacets(this.translator);

                context.nmsCategories = categoryContext.categories;
                context.nmsAnimalSubcategories = categoryContext.animalSubcategories;
                context.nmsActiveCategoryLabel = (
                    _.find(categoryContext.animalSubcategories, function activeAnimalCategory(category) {
                        return category.isActive;
                    }) ||
                    _.find(categoryContext.categories, function activePrimaryCategory(category) {
                        return category.isActive;
                    }) ||
                    {label: 'Categories'}
                ).label;
                context.nmsShowAnimalSubcategories = categoryContext.showAnimalSubcategories;
                context.nmsPageHeading = categoryContext.heading;
                context.nmsPageSubtitle = categoryContext.subtitle;
                context.nmsBreadcrumbParent = categoryContext.breadcrumbParent;
                context.nmsBreadcrumbParentUrl = categoryContext.breadcrumbParentUrl;
                context.nmsBreadcrumbCurrent = categoryContext.breadcrumbCurrent;
                context.nmsIsBuyFluShots = isBuyFluShotsSite();
                context.nmsIsCardView = nmsDisplayMode === 'card';
                context.nmsIsCollectionEntering = !!pendingCollectionUpdate;
                context.nmsIsCategoryTitleEntering = !!(
                    pendingCollectionUpdate && pendingCollectionUpdate.changesCategoryTitle
                );
                context.nmsIsDisplayEntering = displayTransitionActive;
                context.nmsIsEmpty = this.model.get('total') <= 0;
                context.nmsShowFilters = !!(
                    context.hasItemsAndFacets ||
                    appliedFacets.length
                );
                context.showResults = true;

                return context;
            };

            if (originalGetTitle) {
                FacetsBrowseView.prototype.getTitle = function getNMSProductsTitle() {
                    var title = originalGetTitle.apply(this, arguments);

                    return String(title || '')
                        .replace(/custitem_nms_facet_form/gi, 'Form')
                        .replace(/custitemnms_facet_manufacturer/gi, 'Manufacturer')
                        .replace(/custitemnms_facet_strength/gi, 'Strength');
                };
            }

            FacetsBrowseView.prototype._gotoFacets = function gotoNMSFacets(event) {
                captureFacetScroll(this);
                beginCollectionUpdate(event && event.currentTarget, 'results');
                return originalGotoFacets.apply(this, arguments);
            };

            FacetsBrowseView.prototype.showContent = function showNMSProductsContent() {
                var view = this;
                var scrollGuard = function keepNMSProductsViewportStable() {
                    var state = pendingFacetScroll;
                    var currentPageY;

                    if (!state) {
                        return;
                    }

                    currentPageY = window.pageYOffset || document.documentElement.scrollTop || 0;
                    if (currentPageY !== state.pageY) {
                        window.scrollTo(0, state.pageY);
                    }
                };
                var stopScrollGuard = function stopNMSProductsViewportGuard() {
                    window.removeEventListener('scroll', scrollGuard);
                };
                var promise;

                if (pendingFacetScroll && typeof window !== 'undefined') {
                    window.addEventListener('scroll', scrollGuard);
                }

                promise = originalShowContent.apply(this, arguments);

                closeCategorySheet(false);

                if (promise && promise.done) {
                    pendingCollectionRequest = promise;
                    promise.done(function restoreNMSProductsScroll() {
                        if (pendingCollectionRequest === promise) {
                            pendingCollectionRequest = null;
                        }
                        stopScrollGuard();
                        restoreFacetScroll(view);
                        revealCollectionUpdate(view);
                    });
                    promise.fail(function clearNMSProductsScroll() {
                        if (
                            pendingCollectionUpdate &&
                            pendingCollectionUpdate.abortedRequest === promise
                        ) {
                            stopScrollGuard();
                            return;
                        }
                        if (pendingCollectionRequest === promise) {
                            pendingCollectionRequest = null;
                        }
                        stopScrollGuard();
                        if (facetRequestRestarting) {
                            return;
                        }
                        cancelCollectionUpdate();
                        pendingFacetScroll = null;
                    });
                } else {
                    stopScrollGuard();
                    restoreFacetScroll(view);
                    revealCollectionUpdate(view);
                }

                return promise;
            };
        }

        function installFacetedNavigationView() {
            var originalChildViews = FacetsFacetedNavigationView.prototype.childViews || {};
            var originalGetContext = FacetsFacetedNavigationView.prototype.getContext;
            var originalItemsFactory = originalChildViews['Facets.FacetedNavigationItems'];

            FacetsFacetedNavigationView.prototype.template = nmsFacetsFacetedNavigationTpl;
            FacetsFacetedNavigationView.prototype.getContext = function getNMSFacetedNavigationContext() {
                var context = originalGetContext.apply(this, arguments);
                var appliedFacets = getVisibleAppliedFacets(this.options.translator);

                context.hasAppliedFacets = appliedFacets.length > 0;
                context.nmsAppliedFacetsEntering = !!(
                    pendingCollectionUpdate &&
                    pendingCollectionUpdate.facetLabels.length === 0 &&
                    appliedFacets.length
                );

                return context;
            };
            FacetsFacetedNavigationView.prototype.childViews = _.extend({}, originalChildViews, {
                'Facets.FacetedNavigationItems': function visibleNMSFacets() {
                    var originalFacets = this.options.facets;
                    var view;

                    if (isBuyFluShotsSite()) {
                        this.options.facets = _.reject(originalFacets || [], isBuyFluShotsPriceFacet);
                    }

                    view = originalItemsFactory.apply(this, arguments);
                    this.options.facets = originalFacets;

                    return view;
                },
                'Facets.FacetsDisplay': function selectedNMSFacets() {
                    var translator = this.options.translator;
                    var facets = getVisibleAppliedFacets(translator).sort(function sortFacets(first, second) {
                        return second.config.priority - first.config.priority;
                    });

                    return new FacetsFacetsDisplayView({
                        facets: facets,
                        translator: translator
                    });
                }
            });
        }

        function bindFacetUpdateFeedback() {
            var selector =
                '.facets-faceted-navigation-item-facet-option,' +
                '[data-type="facet-selected"],' +
                '.facets-facets-display-clear,' +
                '.facets-faceted-navigation-item-facet-clear,' +
                '.facets-faceted-navigation-facets-clear,' +
                '.facets-item-list-show-selector,' +
                '.facets-item-list-sort-selector,' +
                '.facets-facet-browse-pagination a,' +
                '.nms-products-category-chip,' +
                '.nms-products-animal-subchip,' +
                '.nms-products-category-sheet a';
            var captureUpdate = function captureNMSInPageUpdate(event) {
                var target = jQuery(event.target).closest(selector);

                if (
                    !target.length ||
                    !target.closest('.nms-products-page').length ||
                    (event.type === 'click' && target.is('select')) ||
                    target.attr('aria-current') === 'page'
                ) {
                    return;
                }

                if (
                    event.type === 'click' &&
                    target.is('.facets-faceted-navigation-item-facet-option') &&
                    !target.attr('data-nms-facet-restart') &&
                    restartFacetRequest(event, target)
                ) {
                    return;
                }

                target.removeAttr('data-nms-facet-restart');

                if (currentBrowseView) {
                    captureFacetScroll(
                        currentBrowseView,
                        target.is('.facets-facet-browse-pagination a')
                    );
                }
                if (target.is('.nms-products-category-chip, .nms-products-animal-subchip')) {
                    animateCategoryIndicator(target.get(0));
                }
                beginCollectionUpdate(target.get(0), target.is('select') ? 'sort' : 'results');
            };

            document.addEventListener('click', captureUpdate, true);
            document.addEventListener('change', captureUpdate, true);
            jQuery.ajaxPrefilter(function markNMSInPageRequest(options) {
                if (typeof window !== 'undefined' && window.NMSInPageUpdateActive) {
                    options.global = false;
                    options.nmsInPageUpdate = true;
                }
            });
        }

        function installFacetedNavigationItemView() {
            var originalInitialize = FacetsFacetedNavigationItemView.prototype.initialize;
            var originalGetContext = FacetsFacetedNavigationItemView.prototype.getContext;

            FacetsFacetedNavigationItemView.prototype.template = nmsFacetsFacetedNavigationItemTpl;
            FacetsFacetedNavigationItemView.prototype.events = _.extend(
                {},
                FacetsFacetedNavigationItemView.prototype.events,
                {
                    'input [data-action="nms-filter-search"]': 'filterNMSFacetOptions',
                    'shown.bs.collapse .facets-faceted-navigation-item-facet-optionlist-extra': 'markNMSFacetOptionsExpanded',
                    'hidden.bs.collapse .facets-faceted-navigation-item-facet-optionlist-extra': 'markNMSFacetOptionsCollapsed'
                }
            );

            FacetsFacetedNavigationItemView.prototype.initialize = function initializeNMSFacet() {
                originalInitialize.apply(this, arguments);

                if (getSearchableFacet({
                    facetId: this.facetId,
                    facetDisplayName: this.facet_config && this.facet_config.name
                })) {
                    this.template = nmsFacetsFacetedNavigationItemTpl;
                }
            };

            FacetsFacetedNavigationItemView.prototype.getContext = function getNMSFacetContext() {
                var searchable = getSearchableFacet({facetId: this.facetId,
                    facetDisplayName: this.facet_config && this.facet_config.name});
                var values = this.model && this.model.get('values');
                var validValues = _.isArray(values) && _.filter(values, function usableFacetValue(value) {
                    return value && typeof value === 'object' && value.url !== '';
                });
                // Hidden options are deferred in both generated HTML and the browser.
                // The complete shared model is restored before context returns;
                // native search / See More materializes it when requested.
                var lazy = searchable && !this.nmsFacetOptionsReady && this.model.attributes && validValues &&
                    validValues.length > FACET_PREVIEW_COUNT && this.facet_config &&
                    this.facet_config.behavior !== 'range' &&
                    (!this.facet_config.colors || _.isEmpty(this.facet_config.colors));
                var context;
                // Native context builds every option URL; initially only the visible
                // previews need links. Restore the shared model without emitting events.
                if (lazy) this.model.attributes.values = validValues.slice(0, FACET_PREVIEW_COUNT);
                try { context = originalGetContext.apply(this, arguments); }
                finally { if (lazy) this.model.attributes.values = values; }
                if (isHiddenFacet(context.facetId) || isBuyFluShotsPriceFacet({id: context.facetId})) {
                    context.showFacet = false;
                    return context;
                }
                context.nmsIsSearchable = !!searchable;
                context.nmsShowCheckbox = context.isMultiSelect || isBuyFluShotsSite();
                if (searchable) {
                    context.facetDisplayName = searchable.displayName || context.facetDisplayName;
                    context.displayValues = _.first(context.values, FACET_PREVIEW_COUNT);
                    context.extraValues = lazy ? [] : _.rest(context.values, FACET_PREVIEW_COUNT);
                    context.showExtraValues = !!lazy || context.extraValues.length > 0;
                    context.nmsSearchLabel = searchable.label;
                    context.nmsSearchPlaceholder = searchable.placeholder;
                }
                this.nmsFacetOptionsDeferred = !!lazy;
                return context;
            };

            FacetsFacetedNavigationItemView.prototype.ensureNMSFacetOptions = function ensureNMSFacetOptions() {
                if (!this.nmsFacetOptionsDeferred) return;
                this.nmsFacetOptionsReady = true;
                var context = this.getContext();
                // Reuse the incumbent escaped template, exact URLs and selected state.
                // Keep the mounted search input, collapse control and native handlers.
                var markup = jQuery(nmsFacetsFacetedNavigationItemTpl(context));
                var rows = markup.find('.facets-faceted-navigation-item-facet-optionlist-extra').children();
                this.$('.facets-faceted-navigation-item-facet-optionlist-extra').empty().append(rows);
                this.nmsFacetOptionsDeferred = false;
            };

            var originalSeeMoreLess = FacetsFacetedNavigationItemView.prototype.toggleSeeMoreLess;
            FacetsFacetedNavigationItemView.prototype.toggleSeeMoreLess = function toggleNMSSeeMoreLess() {
                this.ensureNMSFacetOptions();
                return originalSeeMoreLess.apply(this, arguments);
            };

            FacetsFacetedNavigationItemView.prototype.expandNMSFacetOptions = function expandNMSFacetOptions() {
                var extra = this.$('.facets-faceted-navigation-item-facet-optionlist-extra');
                var seeMore = this.$('[data-action="see-more"]');

                if (extra.length && !extra.hasClass('in') && !extra.hasClass('collapsing') && seeMore.length) {
                    seeMore.trigger('click');
                }
            };

            FacetsFacetedNavigationItemView.prototype.syncNMSFacetOptionsState = function syncNMSFacetOptionsState(isExpanded) {
                this.$('[data-action="see-more"]')
                    .toggleClass('nms-facet-see-more-expanded', isExpanded)
                    .attr('aria-expanded', isExpanded ? 'true' : 'false');
            };

            FacetsFacetedNavigationItemView.prototype.markNMSFacetOptionsExpanded = function markNMSFacetOptionsExpanded() {
                this.syncNMSFacetOptionsState(true);
            };

            FacetsFacetedNavigationItemView.prototype.markNMSFacetOptionsCollapsed = function markNMSFacetOptionsCollapsed() {
                this.syncNMSFacetOptionsState(false);
            };

            FacetsFacetedNavigationItemView.prototype.filterNMSFacetOptions = function filterNMSFacetOptions(event) {
                var query = String(jQuery(event.currentTarget).val() || '').replace(/^\s+|\s+$/g, '').toLowerCase();
                var items;
                var matches = 0;

                if (query) {
                    this.ensureNMSFacetOptions();
                    this.expandNMSFacetOptions();
                }
                items = this.$('[data-nms-facet-label]');

                items.each(function filterFacetOption() {
                    var item = jQuery(this);
                    var visible = !query || String(item.attr('data-nms-facet-label') || '').toLowerCase().indexOf(query) >= 0;

                    item.prop('hidden', !visible);
                    if (visible) {
                        matches += 1;
                    }
                });

                this.$('.nms-facet-search-empty').prop('hidden', matches > 0);
            };
        }

        function installItemCellView() {
            var originalChildViews = FacetsItemCellView.prototype.childViews || {};
            var originalGetContext = FacetsItemCellView.prototype.getContext;
            var originalDestroy = FacetsItemCellView.prototype.destroy;
            var NMSProductActionView = CartQuickAddToCartView.extend({
                template: nmsFacetsItemActionTpl,
                getContext: function getNMSProductActionContext() {
                    var context = CartQuickAddToCartView.prototype.getContext.apply(this, arguments);

                    context.nmsLoginToBuy = requiresProductsLogin(this.model);
                    context.nmsLoginUrl = productsLoginUrl();
                    return context;
                }
            });
            var NMSProductCardActionView = CartQuickAddToCartView.extend({
                template: nmsFacetsItemCardActionTpl,
                childViews: _.extend({}, CartQuickAddToCartView.prototype.childViews || {}, {
                    'NMS.Card.Price': function nmsCardPrice() {
                        return new NMSProductPriceView({
                            model: this.model,
                            origin: 'ITEMCELL'
                        });
                    }
                }),
                getContext: function getNMSProductCardActionContext() {
                    var context = CartQuickAddToCartView.prototype.getContext.apply(this, arguments);

                    context.nmsLoginToBuy = requiresProductsLogin(this.model);
                    context.nmsLoginUrl = productsLoginUrl();
                    return context;
                }
            });

            FacetsItemCellView.prototype.template = nmsFacetsItemCellListTpl;

            FacetsItemCellView.prototype.getNMSProduct = function getNMSProduct() {
                if (!this.nmsProduct) {
                    this.nmsProduct = new ProductModel({
                        item: this.model,
                        quantity: this.model.get('_minimumQuantity', true) || 1
                    });
                }

                return this.nmsProduct;
            };

            FacetsItemCellView.prototype.childViews = _.extend({}, originalChildViews, {
                'NMS.Product.Price': function nmsProductPrice() {
                    return new NMSProductPriceView({
                        model: this.getNMSProduct(),
                        origin: 'ITEMCELL',
                        nmsLoginToBuy: true
                    });
                },
                'NMS.Product.Action': function nmsProductAction() {
                    return new NMSProductActionView({
                        model: this.getNMSProduct(),
                        application: this.options.application
                    });
                },
                'NMS.Product.CardAction': function nmsProductCardAction() {
                    return new NMSProductCardActionView({
                        model: this.getNMSProduct(),
                        application: this.options.application
                    });
                }
            });

            FacetsItemCellView.prototype.getContext = function getNMSItemCellContext() {
                var context = originalGetContext.apply(this, arguments);
                context.nmsCardImageSize = getNMSCardImagePreset(false);
                context.nmsCardImageSize2x = getNMSCardImagePreset(true);

                context.nmsDisplayName = formatCatalogLabel(getItemValue(this.model, [
                    'storedisplayname2',
                    'displayname',
                    '_name'
                ]));
                context.nmsStrength = getItemValue(this.model, ['custitem_t3_item_strength']);
                context.nmsForm = formatCatalogLabel(getItemValue(this.model, ['custitem_t3_item_dosage_form']));
                context.nmsManufacturer = formatCatalogLabel(getItemValue(this.model, ['manufacturer']));
                context.nmsUnitSize = getItemValue(this.model, ['custitem_sip_pedigree_item_size']);

                return context;
            };

            FacetsItemCellView.prototype.destroy = function destroyNMSItemCell() {
                if (this.nmsProduct) {
                    this.model.off('change', this.nmsProduct.onItemChangeUpdateLine, this.nmsProduct);
                    this.nmsProduct.off();
                    this.nmsProduct = null;
                }

                return originalDestroy.apply(this, arguments);
            };
        }

        function installCartConfirmationView() {
            var originalGetContext = CartConfirmationView.prototype.getContext;

            CartConfirmationView.prototype.template = nmsCartConfirmationModalTpl;

            CartConfirmationView.prototype.getContext = function getNMSCartConfirmationContext() {
                var context = originalGetContext.apply(this, arguments);
                var viewModel = this.model;
                var sourceModel = context.model || viewModel;
                var model = sourceModel && sourceModel.toJSON
                    ? sourceModel.toJSON()
                    : sourceModel;
                var nativeItem = viewModel && typeof viewModel.get === 'function'
                    ? viewModel.get('item')
                    : null;
                var item = nativeItem || (model && model.item);
                var displayName = item && (
                    item.storedisplayname2 ||
                    item.displayname ||
                    item._name ||
                    item.itemid
                );

                if (item && item.toJSON) {
                    item = item.toJSON();
                    displayName = item.storedisplayname2 || item.displayname || item._name || item.itemid;
                }

                if (displayName) {
                    context.model = _.extend({}, model, {
                        item: _.extend({}, item, {
                            displayname: formatCatalogLabel(displayName)
                        })
                    });
                }

                return context;
            };
        }

        function installEmptyView() {
            FacetsEmptyView.prototype.template = nmsFacetsEmptyTpl;
        }

        return {
            mountToApp: function mountToApp() {
                if (installed) {
                    return;
                }

                installed = true;
                installCardImageUrlHelper();
                installCardDisplayOption();
                installBuyFluShotsProductsRoute();
                installFacetTranslator();
                installBrowseView();
                installFacetedNavigationView();
                installFacetedNavigationItemView();
                installItemCellView();
                installCartConfirmationView();
                installEmptyView();
                bindCategorySheetLifecycle();
                bindDisplayModeLifecycle();
                bindFacetUpdateFeedback();
            }
        };
    }
);
